module.exports = __webpack_public_path__ + "/ddb359a0f5b85085d30788bb7e8a7220.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/clouds_evernote.svg
 ** module id = 1257
 ** module chunks = 0
 **/